import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

import Home from "@/pages/Home";
import Artists from "@/pages/Artists";
import ArtistDetail from "@/pages/ArtistDetail";
import HowItWorks from "@/pages/HowItWorks";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ClientDashboard from "@/pages/ClientDashboard";
import ArtistDashboard from "@/pages/ArtistDashboard";
import AdminDashboard from "@/pages/AdminDashboard";

function Shell({ children }) {
  return (
    <>
      <Navbar />
      <main className="pt-16">{children}</main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" theme="dark" richColors />
          <Routes>
            <Route path="/" element={<Shell><Home /></Shell>} />
            <Route path="/artistes" element={<Shell><Artists /></Shell>} />
            <Route path="/artistes/:id" element={<Shell><ArtistDetail /></Shell>} />
            <Route path="/comment-ca-marche" element={<Shell><HowItWorks /></Shell>} />
            <Route path="/a-propos" element={<Shell><About /></Shell>} />
            <Route path="/contact" element={<Shell><Contact /></Shell>} />
            <Route path="/connexion" element={<Login />} />
            <Route path="/inscription" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/espace-client"
              element={
                <ProtectedRoute roles={["client", "admin"]}>
                  <Shell><ClientDashboard /></Shell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/espace-artiste"
              element={
                <ProtectedRoute roles={["artist", "admin"]}>
                  <Shell><ArtistDashboard /></Shell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <Shell><AdminDashboard /></Shell>
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
